export const getPageIdentifier = () => {
  const currentPage = window.location.pathname;
  const cleanedPath = currentPage.replace(/^\/|\/$/g, "");
  const parts = cleanedPath.split("/");
  const lastPart = parts[parts.length - 1];

  // Check if the last part is a number
  if (!isNaN(lastPart)) {
    // If it's a number, return the second last part
    return parts[parts.length - 2];
  } else {
    // If it's not a number, return the last part
    return lastPart;
  }
};

export const isPageIncluded = (pageArray, currentPage) => {
  // Check if any of the elements in the array are present in the current page
  return pageArray?.some((page) => currentPage?.includes(page));
};
